import { memo } from 'react';
import PropTypes from 'prop-types';

import { CHART_INK } from '../constants/chartPalette';

/**
 * Dashed horizontal gridlines with a solid baseline, drawn inside a plot's own
 * `0 0 100 100` viewBox.
 *
 * Absolutely positioned by the caller behind the marks. `vectorEffect` keeps
 * the strokes hairline-thin no matter how far the non-uniform `preserveAspect`
 * scaling stretches the box — without it a chart in a wide slot draws 4px
 * horizontal rules and 0.2px verticals.
 *
 * @param {object} props
 * @param {number} [props.rows=4] Gridlines above the baseline.
 */
function ChartGrid({ rows = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <line
          key={index}
          x1="0"
          x2="100"
          y1={(index * 100) / rows}
          y2={(index * 100) / rows}
          stroke={CHART_INK.line}
          strokeWidth="0.5"
          strokeDasharray="2,4"
          vectorEffect="non-scaling-stroke"
        />
      ))}
      <line
        x1="0"
        x2="100"
        y1="100"
        y2="100"
        stroke={CHART_INK.line}
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
      />
    </>
  );
}

ChartGrid.propTypes = {
  rows: PropTypes.number,
};

export default memo(ChartGrid);
